
import { soldOut, deliveryOnly, noPickupTime } from "./js/common.js"
import freeGiftDrawer from "@/components/collect/free-gift-drawer"
import { getCollectProcess } from "@/api/collect"
import { flattenSelectItem } from "@/components/collect/format"
import { callAsync } from "@/utils/cartResponse"

export default {
  name: "FreeGifts",
  components: {
    freeGiftDrawer
  },
  provide() {
    return {
      getStoreId: () => this.storeId,
      source: "freeGifts"
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    storeId: {
      type: [Number, String],
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    slaveStore: {
      type: Boolean,
      default: false
    },
    shipmentType: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {
      loadingInstance: null,
      requestSuccess: false,
      giftItem: {},
      dialogInfo: {},
      autoGift: false
    }
  },
  computed: {
    promotionList() {
      const result = this.items[0] || {}
      return result.promotionList || []
    }
  },
  mounted() {
    console.log("giftItems===>", this.items, this.promotionList)
    this.$bus.$off("add-cart-success", this.handleAddGiftSuccess)
    this.$bus.$on("add-cart-success", this.handleAddGiftSuccess)
  },
  methods: {
    soldOut,
    noPickupTime,
    deliveryOnly,
    showAbnormalState(item) {
      const state = item.wareStatus?.abnormalState
      const invalidWareFlag = item.wareStatus?.invalidWareFlag
      // 當 abnormalState 為 5 且 invalidWareFlag 不等於 1 時，不渲染
      if (state === 5 && invalidWareFlag !== 1) {
        return false
      }
      // 其他情況下，檢查 abnormalState 是否在指定列表中
      return [10, 11, 12, 5].includes(state)
    },
    getAbnormalStateText(item) {
      const state = item.wareStatus?.abnormalState
      switch (state) {
        case 10:
          // 仅香港
          return this.$t("cart.salesAreaHK")
        case 11:
          // 仅澳门
          return this.$t("cart.salesAreaMacao")
        case 12:
          // 指定门店
          return this.$t("cart.designatedStore")
        case 5:
          //  无履约实效下 售罄
          if (item.wareStatus.invalidWareFlag === 1 && ![10, 11, 12].includes(state)) return this.$t("cart.soldout")
        // eslint-disable-next-line no-fallthrough
        default:
          return ""
      }
    },
    // 自动增
    isAutoGift(item) {
      return item.promotionGift && item.promotionGift.isAutoGift == 1
    },
    maxGiftQty(item) {
      return item.promotionGift && item.promotionGift.maxGiftQty
    },
    // 已选择的赠品列表
    selectedGiftWareList(item) {
      return (item.promotionGift && item.promotionGift.selectedGiftWareList) || []
    },
    // 可选择的赠品列表
    optGiftWareList(item) {
      return (item.promotionGift && item.promotionGift.optGiftWareList) || []
    },
    // 赠品未选择完成
    isGiftUnselectedCompleted(item) {
      return this.selectedGiftWareList(item).length < this.maxGiftQty(item)
    },
    // 已选择的赠品存在无效商品
    isSelectedExistSoldOut(item) {
      return this.selectedGiftWareList(item).some(ware => this.soldOut(ware))
    },
    // 全部无效
    isAllSoldOut(item) {
      return this.selectedGiftWareList(item).every(ware => this.soldOut(ware) && !this.noPickupTime(ware))
    },
    toProductDetail(item) {
      if (this.slaveStore) return
      this.$navigation.push({
        path: `${this.MAIN_PATH}/p/${encodeURIComponent(item.wareName)}/i/${item.skuId}.html`
      })
    },
    handleAddGiftSuccess(source) {
      this.$nextTick(() => {
        if (source === "freeGifts") {
          this.getDialogInfo()
        }
      })
    },
    handleDelete(item) {
      this.$emit("handleGiftDelete", {
        type: "gift",
        promotionId: item.promotionId,
        items: this.selectedGiftWareList(item)
      })
    },
    startLoading() {
      this.loadingInstance = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
    },
    endLoading() {
      this.loadingInstance && this.loadingInstance.close()
    },
    async getDialogInfo() {
      const params = {
        storeId: this.storeId,
        shipmentType: this.shipmentType,
        promotionId: this.giftItem.promotionId,
        bestOffer: !!(this.giftItem.promotionInfo && this.giftItem.promotionInfo.bestofferFlag === 1)
      }
      const [error, { data }] = await callAsync(getCollectProcess(params))
      if (data) {
        this.requestSuccess = true
        this.dialogInfo = data.dialogInfo || {}
        // this.dialogInfo.optItemList = this.dialogInfo.optItemList.concat(this.dialogInfo.optItemList).concat(this.dialogInfo.optItemList).concat(this.dialogInfo.optItemList).concat(this.dialogInfo.optItemList)
        // this.dialogInfo.optItemList = this.dialogInfo.optItemList?.map(v => ({
        //   ...v,
        //   group: "a"
        // }))
        this.autoGift = data.autoGift
        flattenSelectItem(this.dialogInfo.selectedItemInfo)
      }

      return [error, data]
    },
    openGiftDrawer(item) {
      console.log("item====>", item, this.storeId)
      this.requestSuccess = false
      this.giftItem = item

      const soldOutItems = this.selectedGiftWareList(item).filter(ware => this.soldOut(ware)) || []

      const cb = async () => {
        this.startLoading()
        const [error, data] = await this.getDialogInfo()
        this.endLoading()
        if (data) {
          this.$nextTick(() => {
            this.$refs.freeGiftDrawer.open()
          })
        }
      }
      // 打开弹窗之前先删除失效的赠品
      if (soldOutItems.length) {
        this.$emit("handleGiftDelete", {
          type: "gift",
          promotionId: item.promotionId,
          items: soldOutItems,
          cb
        })
      } else {
        cb()
      }
    }
  }
}
